import React from 'react';
import HelpMenu from 'components/HelpMenu';

function WorkspaceHelpMenu(props) {
  return (
    <HelpMenu align="right" {...props} />
  );
}

export default WorkspaceHelpMenu;
